var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('o-item-card',{attrs:{"showGetGotControl":true,"item":_vm.data.itemViewed,"currentUser":_vm.currentUser,"isPreview":false,"isMapView":true,"smallWindow":_vm.smallWindow}})
}
var staticRenderFns = []

export { render, staticRenderFns }